'use client'

import type { ReactNode } from 'react'
import { cx } from '../utils/cx'

interface FilterChipProps {
  on?: boolean
  onChange?: (next: boolean) => void
  heart?: boolean
  children?: ReactNode
  className?: string
}

export function FilterChip({ on, onChange, heart, children, className }: FilterChipProps) {
  return (
    <button
      type="button"
      className={cx('st-filter-chip', on && 'on', className)}
      data-on={on || undefined}
      onClick={() => onChange?.(!on)}>
      {heart && <span className="heart" aria-hidden />}
      {children}
    </button>
  )
}
